// @ts-strict-ignore

import {
  Component,
  Input,
} from "@angular/core";

@Component({
  selector: 'lm-drill-view-unknown',
  standalone: false,
  template: `
      <div class="lm-is-indent field">
        @if (false) {
          <div class="fieldset-title">{{info.dataView.representativeText}}</div>
        }
        <div class="label">{{ 'DrillAroundErrorMsg' | translate: info.drillAction.drillName }}</div>
      </div>
      `
})
export class LMDrillViewUnknownComponent {
  @Input() info!: LMDrillAroundViewInfo;

  constructor() {
  }
}
